import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./FseTableStyle";
import FseTable from "components/root/FseTable";

const DashboardTable = React.memo((props) => {
  return (
    <>
      <FseTable />

    </>
  );
});

export default withRouter(DashboardTable);
